
import { defineComponent } from 'vue';
export default defineComponent({
    props: {
        options: {
            type: Array as () => Array<{title: string, value: string}>,
            required: true,
        },
        default: {
            type: String,
            required: false,
            default: null,
        },
        tabindex: {
            type: Number,
            required: false,
            default: 0,
        },
    },
    data() {
        return {
            selected: this.default
                ? this.default
                : this.options.length > 0
                    ? this.options[0].title
                    : null,
            open: false,
        };
    },
    mounted() {
        this.$emit("input", this.selected);
    },
});
